import { render, staticRenderFns } from "./VehicleGroup.vue?vue&type=template&id=6deb5888&scoped=true"
import script from "./VehicleGroup.vue?vue&type=script&lang=js"
export * from "./VehicleGroup.vue?vue&type=script&lang=js"
import style0 from "./VehicleGroup.vue?vue&type=style&index=0&id=6deb5888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deb5888",
  null
  
)

export default component.exports